import React, { useState } from "react";
import style from "./style.module.scss";
import LoginSignup from "../Common/Modals/LoginSignup/LoginSignup";
import MenuWrapper from "./MenuWrapper";
import InnerContainer from "./InnerContainer";

const Navbar = ({ path, user, modalState, setModalState }) => {

  const [visible, setVisible] = useState(false); //state for mobile menu
  return (
    <div
      className={style.headerWpaerr}
      style={{
        display:
          (path === "logi" && "none") ||
          (path === "sign" && "none") ||
          (path === "rese" && "none"),
      }}>
      <div className={style.header}>
        <MenuWrapper
          path={path}
          user={user}
          modalState={modalState}
          setModalState={setModalState}
          visible={visible}
          setVisible={setVisible}
        />

        <InnerContainer
          path={path}
          user={user}
          modalState={modalState}
          setModalState={setModalState}
          setVisible={setVisible}
        />
        <LoginSignup modalState={modalState} setModalState={setModalState} />
      </div>
    </div>
  );
};

export default Navbar;
